module.exports = __webpack_public_path__ + "static/tfg_mobile.a9244752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/tfg_mobile.png
// module id = 2175
// module chunks = 61762850755587